import React, { useEffect, useState, Fragment } from 'react'
import { Card, Col, Container, Form, Row, InputGroup } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { formato_rut, validaPegadoTelefono, prefijoTelefonoPais, isValidParam } from '../../../common/Formatos'
import { obtenerRutConductor } from '../../../store/actions/implicado-action'

const Conductor = ({ formik, setRutConductorFinal }) => {
  const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
  const { cfg_form_implicado, antecedentesCasos } = data_datos_generales
  const data_datos_implicado = useSelector((state) => state.implicadoReducer)
  const { datosPantalla, comboPais, comboComunas } = data_datos_implicado

  const [datosSiniestro, setDatosSiniestro] = useState({})
  const [rutConductor, setRutConductor] = useState('')
  const [rutConductorNoFormato, setRutConductorNoFormato] = useState('')
  const [nombreConductor, setNombreConductor] = useState('')
  const [direccionConductor, setDireccionConductor] = useState('')
  const [emailConductor, setEmailConductor] = useState('')
  const [paisConductor, setPaisConductor] = useState('')
  const [paisMovilConductor, setPaisMovilConductor] = useState('')
  const [fonoConductor, setFonoConductor] = useState('')
  const [movilConductor, setMovilConductor] = useState('')
  const [comunaConductor, setComunaConductor] = useState('')
  const [ciudadConductor, setCiudadConductor] = useState('')
  const [obsConductor, setObsConductor] = useState('')
  
  const distpatch=useDispatch()
  useEffect(() => {
    
    distpatch(obtenerRutConductor(rutConductorNoFormato))
  }, [rutConductorNoFormato])

  useEffect(() => {
    setRutConductorFinal(rutConductorNoFormato)
  }, [rutConductorNoFormato])
  useEffect(() => {
    setRutConductor(
      datosPantalla &&
        datosPantalla.datosPantalla[0]['RutConductor'] !== undefined &&
        datosPantalla.datosPantalla[0]['RutConductor'] !== null
        ? formato_rut(
            datosPantalla.datosPantalla[0]['RutConductor']
            // + datosPantalla.datosPantalla['R']
          )
        : ''
    )
    setRutConductorNoFormato(
      datosPantalla && datosPantalla.datosPantalla[0]['RutConductor']
      //+ datosPantalla.datosPantalla['dvIdGirador']
    )
    setNombreConductor(
      datosPantalla &&
        datosPantalla.datosPantalla[0]['NombreConductor'] !== undefined &&
        datosPantalla.datosPantalla[0]['NombreConductor'] !== null &&
        datosPantalla.datosPantalla[0]['NombreConductor'] !== ''
        ? datosPantalla.datosPantalla[0]['NombreConductor']
        : ''
    )
    setDireccionConductor(
      datosPantalla &&
        datosPantalla.datosPantalla[0]['DireccionConductor'] !== undefined &&
        datosPantalla.datosPantalla[0]['DireccionConductor'] !== null &&
        datosPantalla.datosPantalla[0]['DireccionConductor'] !== ''
        ? datosPantalla.datosPantalla[0]['DireccionConductor']
        : ''
    )
    setEmailConductor(
      datosPantalla &&
        datosPantalla.datosPantalla[0]['EmailConductor'] !== undefined &&
        datosPantalla.datosPantalla[0]['EmailConductor'] !== null &&
        datosPantalla.datosPantalla[0]['EmailConductor'] !== ''
        ? datosPantalla.datosPantalla[0]['EmailConductor']
        : ''
    )
    setPaisConductor(18002)
    setPaisMovilConductor(18002)
    setFonoConductor(
      datosPantalla &&
        datosPantalla.datosPantalla[0]['FonoConductor'] !== undefined &&
        datosPantalla.datosPantalla[0]['FonoConductor'] !== null &&
        datosPantalla.datosPantalla[0]['FonoConductor'] !== ''
        ? datosPantalla.datosPantalla[0]['FonoConductor']
        : ''
    )
    setMovilConductor(
      datosPantalla &&
        datosPantalla.datosPantalla[0]['MovilConductor'] !== undefined &&
        datosPantalla.datosPantalla[0]['MovilConductor'] !== null &&
        datosPantalla.datosPantalla[0]['MovilConductor'] !== ''
        ? datosPantalla.datosPantalla[0]['MovilConductor']
        : ''
    )
    setComunaConductor(
      datosPantalla &&
        datosPantalla.datosPantalla[0]['IdComunaConductor'] !== undefined &&
        datosPantalla.datosPantalla[0]['IdComunaConductor'] !== null &&
        datosPantalla.datosPantalla[0]['IdComunaConductor'] !== ''
        ? datosPantalla.datosPantalla[0]['IdComunaConductor']
        : ''
    )
    if( datosPantalla &&
      datosPantalla.datosPantalla[0]['IdComunaConductor'] !== undefined &&
      datosPantalla.datosPantalla[0]['IdComunaConductor'] !== null &&
      datosPantalla.datosPantalla[0]['IdComunaConductor'] !== ''){
      const comunaActual = comboComunas &&
        comboComunas.comboComunas?.find(
          (c) => c.id ===datosPantalla.datosPantalla[0]['IdComunaConductor']
        )
        setCiudadConductor(comunaActual && comunaActual.atr4)
      }
        if (datosPantalla && isValidParam(datosPantalla.datosPantalla[0]['obsConductor'])) {
          setObsConductor(datosPantalla.datosPantalla[0]['obsConductor']);
        }
  }, [datosPantalla])
  return (
    <>
      {/* <Container> */}
      <Card className='mt-1 '>
        <Card.Header
          className='mt-0 mb-0'
          as='h6'
          style={{ backgroundColor: '#D9EDF6', color: '#8578CD' }}
        >
          {cfg_form_implicado
            ? cfg_form_implicado.cfg_form_implicado[
                'gestcasosrecup-editimpl-title-tabcond'
              ]
            : null}
        </Card.Header>
        <Container>
          {cfg_form_implicado ? (
            <div>
              <Row>
                <Col md="3">
                  <Form.Label
                    className='mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-rutcond'
                      ]
                    }
                  </Form.Label>{' '}
                  <br />
                  <Form.Control
                    className='mt-2 w-75'
                    autoComplete='off'
                    value={
                      (formik.values.rutConductor =
                        rutConductor !== undefined && rutConductor)
                    }
                    onChange={(e) => {
                      formik.handleChange(e)
                      setRutConductor(e.target.value)
                      setRutConductorNoFormato(e.target.value)
                    }}
                    onFocus={() =>
                      rutConductor !== ''
                        ? setRutConductor(rutConductorNoFormato)
                        : ''
                    }
                    onBlur={() => {
                      setRutConductor(formato_rut(rutConductor))
                    }}
                    name='rutConductor'
                    error={formik.errors.rutConductor}
                  ></Form.Control>
                  {formik.errors.rutConductor ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.rutConductor}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                </Col>
                <Col md="4">
                  <Form.Label
                    className=' mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-nomcond'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Control
                    className='mt-2 w-75'
                    value={
                      (formik.values.nombreConductor =
                        nombreConductor !== undefined && nombreConductor)
                    }
                    onChange={(e) => {
                      formik.handleChange(e)
                      setNombreConductor(e.target.value)
                    }}
                    name='nombreConductor'
                    error={formik.errors.nombreConductor}
                  ></Form.Control>
                  {formik.errors.nombreConductor ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.nombreConductor}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                </Col>
                <Col md="4">
                  <Form.Label
                    className='mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-dircond'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Control
                    className='mt-2'
                    value={
                      (formik.values.direccionConductor =
                        direccionConductor !== undefined && direccionConductor)
                    }
                    onChange={(e) => {
                      formik.handleChange(e)
                      setDireccionConductor(e.target.value)
                    }}
                    name='direccionConductor'
                    error={formik.errors.direccionConductor}
                  ></Form.Control>
                  {formik.errors.direccionConductor ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.direccionConductor}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                </Col>
                </Row>
                <Row>
                <Col md="3">
                  <Form.Label
                    className='mt-2'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-emailcond'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Control
                    className='mt-2'
                    value={
                      (formik.values.emailConductor =
                        emailConductor !== undefined && emailConductor)
                    }
                    onChange={(e) => {
                      formik.handleChange(e)
                      setEmailConductor(e.target.value)
                    }}
                    name='emailConductor'
                    error={formik.errors.emailConductor}
                  ></Form.Control>
                  {formik.errors.emailConductor ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.emailConductor}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                </Col>
                <Col md="4">
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-fonocond'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <InputGroup className='mb-3 w-75'>
                    <Form.Select
                      className='mt-2 w-25'
                      aria-label='Default select example'
                      onChange={(e) => {
                        formik.handleChange(e)

                        setPaisConductor(e.target.value)
                      }}
                      name='paisConductor'
                      value={(formik.values.paisConductor = paisConductor)}
                      error={formik.errors.paisConductor}
                    >
                      <option value={''}>Seleccione...</option>
                      {comboPais &&
                        comboPais.comboPais?.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.nombre}
                          </option>
                        ))}
                    </Form.Select>
                    {formik.errors.paisConductor ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.paisConductor}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                    <Form.Control
                      className='mt-2 w-50'
                      value={
                        (formik.values.fonoConductor =
                          fonoConductor !== undefined && fonoConductor)
                      }
                      onKeyDown={(e) => {
                        //validaNumeros(e)
                      }}
                      onPaste={(e) =>
                        validaPegadoTelefono(e, prefijoTelefonoPais(comboPais, paisConductor), (v) => {
                          formik.setFieldValue('fonoConductor', v)
                          setFonoConductor(v)
                        })
                      }
                      onChange={(e) => {
                        formik.handleChange(e)
                        setFonoConductor(e.target.value)
                      }}
                      name='fonoConductor'
                      error={formik.errors.fonoConductor}
                    ></Form.Control>
                    {formik.errors.fonoConductor ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.fonoConductor}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                  </InputGroup>
                </Col>
                <Col md="4">
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-movilcond'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <InputGroup className='mb-3 w-75'>
                    <Form.Select
                      className='mt-2 w-25'
                      aria-label='Default select example'
                      onChange={(e) => {
                        formik.handleChange(e)

                        setPaisMovilConductor(e.target.value)
                      }}
                      name='paisMovilConductor'
                      value={(formik.values.paisMovilConductor = paisMovilConductor)}
                      error={formik.errors.paisMovilConductor}
                    >
                      <option value={''}>Seleccione...</option>
                      {comboPais &&
                        comboPais.comboPais?.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.nombre}
                          </option>
                        ))}
                    </Form.Select>
                    {formik.errors.paisMovilConductor ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.paisMovilConductor}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                    <Form.Control
                      className='mt-2 w-50'
                      value={
                        (formik.values.movilConductor =
                          movilConductor !== undefined && movilConductor)
                      }
                      onPaste={(e) =>
                        validaPegadoTelefono(e, prefijoTelefonoPais(comboPais, paisMovilConductor), (v) => {
                          formik.setFieldValue('movilConductor', v)
                          setMovilConductor(v)
                        })
                      }
                      onChange={(e) => {
                        formik.handleChange(e)
                        setMovilConductor(e.target.value)
                      }}
                      name='movilConductor'
                      error={formik.errors.movilConductor}
                    ></Form.Control>
                    {formik.errors.movilConductor ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.movilConductor}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                  </InputGroup>
                </Col>
                </Row>
                <Row>
                <Col md="3">
                  <Form.Label
                    className='mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-comuncond'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <InputGroup className='mb-3 w-75'>
                    <Form.Select
                      className='mt-2 w-75'
                      aria-label='Default select example'
                      onChange={(e) => {
                        formik.handleChange(e)
                        const comunaActual =
                          comboComunas &&
                          comboComunas.comboComunas?.find(
                            (c) => c.id === e.target.value
                          )
                        setCiudadConductor(comunaActual.atr4)
                        setComunaConductor(e.target.value)
                      }}
                      name='comunaConductor'
                      value={(formik.values.comunaConductor = comunaConductor)}
                      error={formik.errors.comunaConductor}
                    >
                      <option value={''}>Seleccione...</option>
                      {comboComunas &&
                        comboComunas.comboComunas?.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.nombre}
                          </option>
                        ))}
                    </Form.Select>
                    {formik.errors.comunaConductor ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.comunaConductor}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                  </InputGroup>
                </Col>
                <Col>
                  <Form.Label className='mb-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                    {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-ciudadcond']}
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                    {ciudadConductor}
                  </Form.Text>
                </Col>
              </Row>
              <Row>
                <Col md="10">
                  <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                    {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-obscond'] ? cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-obscond'] : "Observaciones"}
                  </Form.Label>
                  <br />
                  <Form.Control as="textarea" 
                    className='mt-2 mb-2' 
                    rows={2} 
                    onChange={e=>{                    
                      formik.handleChange(e)
                      setObsConductor(e.target.value)                        
                    }}
                    name='obsConductor'                   
                    value={formik.values.obsConductor = obsConductor}
                    error={formik.errors.obsConductor}  
                  />
                  {formik.errors.obsConductor ? (
                    <Form.Text variant="danger" style={{color:"red"}} >
                      {formik.errors.obsConductor}
                    </Form.Text>
                  ) : "" }
                  
                </Col>
              </Row>
              <Row><Col><br></br></Col></Row>
            </div>
          ) : null}
        </Container>
      </Card>
    </>
  )
}

export default Conductor
